import React, { useState } from 'react';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import { Editor } from 'react-draft-wysiwyg';
import {convertToRaw} from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import 'react-table/react-table.css';
import './Quick-Answer.scss';
import { withRouter } from 'react-router-dom';
import InputTag from '../../Components/Input-Tag/Input-Tag'


const NewAnswer = ({ history }) => {

    const [loadingAdicionar, setLoadingAdicionar] = useState(false)
    const [tags, setTags] = useState([])

    const [editorStateTexto, setEditorStateTexto] = useState('')
    const [formState, setFormState] = useState({
        titulo: '',
    })

    const toolbar = {
        inline: {
            inDropdown: false,
            className: undefined,
            component: undefined,
            dropdownClassName: undefined,
            options: ['bold', 'italic', 'underline', 'subscript', 'superscript'],
        },
        blockType: {
            inDropdown: true,
            options: [],
            className: 'd-none'
        },
        fontSize: {
            options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
            className: 'd-none',
            component: undefined,
            dropdownClassName: undefined,
        },
        fontFamily: {
            options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana'],
            className: 'd-none',
            component: undefined,
            dropdownClassName: undefined,
        },
        list: {
            inDropdown: false,
            className: undefined,
            component: undefined,
            dropdownClassName: undefined,
            options: [],
        },
        textAlign: {
            inDropdown: false,
            className: undefined,
            component: undefined,
            dropdownClassName: undefined,
            options: ['center'],
        },
        colorPicker: {
            className: 'd-none',
            component: undefined,
            popupClassName: undefined,
            colors: [],
        },
        link: {
            inDropdown: false,
            className: 'd-none',
            component: undefined,
            popupClassName: undefined,
            dropdownClassName: undefined,
            showOpenOptionOnHover: true,
            defaultTargetOption: '_self',
            options: ['link', 'unlink'],
            linkCallback: undefined
        },
        emoji: {
            className: 'd-none',
            component: undefined,
            popupClassName: undefined,
            emojis: [
                '😀', '😁', '😂', '😃', '😉', '😋', '😎', '😍', '😗', '🤗', '🤔', '😣', '😫', '😴', '😌', '🤓',
                '😛', '😜', '😠', '😇', '😷', '😈', '👻', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '🙈',
                '🙉', '🙊', '👼', '👮', '🕵', '💂', '👳', '🎅', '👸', '👰', '👲', '🙍', '🙇', '🚶', '🏃', '💃',
                '⛷', '🏂', '🏌', '🏄', '🚣', '🏊', '⛹', '🏋', '🚴', '👫', '💪', '👈', '👉', '👉', '👆', '🖕',
                '👇', '🖖', '🤘', '🖐', '👌', '👍', '👎', '✊', '👊', '👏', '🙌', '🙏', '🐵', '🐶', '🐇', '🐥',
                '🐸', '🐌', '🐛', '🐜', '🐝', '🍉', '🍄', '🍔', '🍤', '🍨', '🍪', '🎂', '🍰', '🍾', '🍷', '🍸',
                '🍺', '🌍', '🚑', '⏰', '🌙', '🌝', '🌞', '⭐', '🌟', '🌠', '🌨', '🌩', '⛄', '🔥', '🎄', '🎈',
                '🎉', '🎊', '🎁', '🎗', '🏀', '🏈', '🎲', '🔇', '🔈', '📣', '🔔', '🎵', '🎷', '💰', '🖊', '📅',
                '✅', '❎', '💯',
            ],
        },
        embedded: {
            className: 'd-none',
            component: undefined,
            popupClassName: undefined,
            embedCallback: undefined,
            defaultSize: {
                height: 'auto',
                width: 'auto',
            },
        },
        image: {
            className: "d-none",
            component: undefined,
            popupClassName: undefined,
            urlEnabled: true,
            uploadEnabled: true,
            alignmentEnabled: true,
            uploadCallback: undefined,
            previewImage: false,
            inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
            alt: { present: false, mandatory: false },
            defaultSize: {
                height: 'auto',
                width: 'auto',
            },
        },
        remove: { className: undefined, component: undefined },
        history: {
            inDropdown: false,
            className: undefined,
            component: undefined,
            dropdownClassName: undefined,
            options: ['undo', 'redo'],
        },
    };

    const onEditorStateChange = (newState) => {
        setEditorStateTexto(newState);
    };

    const styleMap = {
        'SUBSCRIPT': {
            fontSize: 8
        },
    };

    const atualizaTags = (_tags) => {
        setTags(_tags)
    }



    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const adicionarFrase = () => {
        setLoadingAdicionar(true);
        const config = new Configurations();
        const _body = {
            "titulo": formState.titulo,
            "descricao": draftToHtml(convertToRaw(editorStateTexto.getCurrentContent())),
            "termo": tags ? tags.map(tag => tag) : []
        };

        axios.post(config.apiBasePath + `/resposta-rapida`, _body)
            .then(() => {
                setLoadingAdicionar(false)

            }).catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() =>
                history.push('lista')
            )
    }


    return (
        <>
            <div className="row detalhes-frase">
                <div className="header-resposta border-left border-bottom border-gray">
                    <div className="row no-gutters py-3 align-items-center">
                        <div className="col-6 pl-2 text-center text-lg-left">
                            <h2 className="">Nova Resposta</h2>
                        </div>

                        <div className="col-2 text-center">
                            <button className="btn btn-outline-success">Salvar</button>
                        </div>
                        <div className="col-2 text-center">
                            <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">Voltar</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className='row' style={{ marginTop: '80px' }}>
                <div className='col-12 pb-2'>
                    <label className="m-0">Título:</label>
                    <input name="titulo" type="text" className="form-control" autoComplete="off" value={formState.titulo} onChange={handleInputChange} />
                </div>

                <div className='col-12 pb-2'>
                    <label className="m-0">Descrição:</label>

                    <Editor
                        editorState={editorStateTexto}
                        wrapperClassName="demo-wrapper"
                        onEditorStateChange={(editorState) => onEditorStateChange(editorState, "editorStateTexto")}
                        toolbar={toolbar}
                        toolbarClassName="custom-toolbar"
                        editorClassName="custom-editor-texto border px-3"
                        handlePastedText={() => false}
                        customStyleMap={styleMap}
                    />
                </div>

                <div className='col-12 pb-2 tags-term'>
                    <label className="m-0">Termos:</label>
                    <InputTag atualizaTags={atualizaTags} tags={tags} textInput={true} />
                </div>

                <div className='col-12 text-right'>
                    {loadingAdicionar ?
                        <div className="spinner-border text-primary" role="status" />
                        :
                        <button className='btn btn-outline-success' onClick={() => adicionarFrase()} >Salvar</button>
                    }

                </div>


            </div>
        </>
    )
}

export default withRouter(NewAnswer);
